import { adminActivityColumns } from '@/columns/adminActivityColumns';
import { fraudLogColumns } from '@/columns/froudLogColumns';
import { loginLogColumns } from '@/columns/loginLogColumns';
import { DataTable } from '@/components/common/DataTable';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

export default function ActivityLogs() {
  return (
    <div className="space-y-8">
      <Tabs defaultValue="adminLog">
        <TabsList className="w-full bg-gray-600 md:w-3/4 justify-between my-4">
          <TabsTrigger value="adminLog">Admin Activity Log</TabsTrigger>
          <TabsTrigger value="playerLog">Player Login Log</TabsTrigger>
          <TabsTrigger value="fraudLog">Fraud Detection Log</TabsTrigger>
        </TabsList>
        <TabsContent value="adminLog">
          <DataTable
            data={[]}
            columns={adminActivityColumns}
            enableSearch
            pageIndex={0}
            total={0}
            onPageChange={function (page: number): void {
              throw new Error('Function not implemented.');
            }}
            onPageSizeChange={function (size: number): void {
              throw new Error('Function not implemented.');
            }}
          />
        </TabsContent>
        <TabsContent value="playerLog">
          <DataTable
            data={[]}
            columns={loginLogColumns}
            enableSearch
            pageIndex={0}
            total={0}
            onPageChange={function (page: number): void {
              throw new Error('Function not implemented.');
            }}
            onPageSizeChange={function (size: number): void {
              throw new Error('Function not implemented.');
            }}
          />
        </TabsContent>
        <TabsContent value="fraudLog">
          <DataTable
            data={[]}
            columns={fraudLogColumns}
            enableSearch
            pageIndex={0}
            total={0}
            onPageChange={function (page: number): void {
              throw new Error('Function not implemented.');
            }}
            onPageSizeChange={function (size: number): void {
              throw new Error('Function not implemented.');
            }}
          />
        </TabsContent>
      </Tabs>
    </div>
  );
}
